import SEO from "components/Seo";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";

const ZakatCalculatorLayout = ({ children }) => {
  const { t } = useTranslation("common");
  const matches = useMobile("md");
  return (
    <div className={``}>
      <SEO title={t("zakat_calculator")} description={t("zakat_description")} />

      <CustomJumbotron
        p="py-4"
        m="mt-0"
        breadCrumbM="my-0"
        className="mt-0 border-bottom"
        title={t(`zakat_calculator`)}
        desc={t(`zakat_description`)}
        customBreadCrumbs={<CustomBreadCrumbs />}
        borderBottom={false}
      />
      <div className={`container mb-4 ${matches ? "px-0" : null}`}>
        {children}
      </div>
    </div>
  );
};

export default ZakatCalculatorLayout;
